"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateRangeFilter = void 0;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _objectWithoutProperties2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireWildcard(require("react"));
var _FilterSelect = require("../../select-components/filter-select/FilterSelect");
var _calendar = require("../../../assets/icons/calendar.svg");
var _dateRangeFilterModule = _interopRequireDefault(require("./date-range-filter.module.scss"));
var _noop = require("../../../utils/noop");
var _classnames = _interopRequireDefault(require("classnames"));
var _useTranslation2 = require("../../../hooks/useTranslation/useTranslation");
var _DateRangePicker = require("../date-range-picker/DateRangePicker");
var _excluded = ["className", "startDate", "endDate", "startDateId", "endDateId", "small", "inline"];
var DateRangeFilter = function DateRangeFilter(_ref) {
  var className = _ref.className,
    startDate = _ref.startDate,
    endDate = _ref.endDate,
    startDateId = _ref.startDateId,
    endDateId = _ref.endDateId,
    _ref$small = _ref.small,
    small = _ref$small === void 0 ? false : _ref$small,
    _ref$inline = _ref.inline,
    inline = _ref$inline === void 0 ? false : _ref$inline,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var isEmpty = !startDate && !endDate;
  var isActive = !!(startDate || endDate);
  var onFocus = (0, _react.useCallback)(function () {
    return setIsOpen(true);
  }, []);
  var onClose = (0, _react.useCallback)(function () {
    setIsOpen(false);
  }, []);
  var emptyFilterOptions = (0, _react.useMemo)(function () {
    return [{
      label: t('date.any'),
      value: t('date.any')
    }];
  }, [t]);
  if (!isOpen && isEmpty) {
    var id = "".concat(startDateId, "__").concat(endDateId);
    return /*#__PURE__*/_react.default.createElement(_FilterSelect.FilterSelect, {
      onFocus: onFocus,
      filterName: t('date.rangeFilterName'),
      defaultValue: t('date.any'),
      value: t('date.any'),
      prefixIcon: /*#__PURE__*/_react.default.createElement("span", {
        className: _dateRangeFilterModule.default['date-range-filter__calendar-icon-container']
      }, /*#__PURE__*/_react.default.createElement(_calendar.ReactComponent, {
        "data-testid": "calendar-icon",
        className: _dateRangeFilterModule.default['date-range-filter__calendar-icon']
      })),
      id: id,
      name: id,
      onChange: _noop.noop,
      options: emptyFilterOptions,
      className: className,
      small: small,
      inline: inline
    });
  }
  return /*#__PURE__*/_react.default.createElement(_DateRangePicker.DateRangePicker, Object.assign({}, rest, {
    initiallyOpen: !startDate && !endDate,
    onClose: onClose,
    startDateId: startDateId,
    endDateId: endDateId,
    className: (0, _classnames.default)(className, (0, _defineProperty2.default)({}, _dateRangeFilterModule.default['date-range-picker--active'], isActive)),
    startDate: startDate,
    endDate: endDate,
    small: small,
    inline: inline
  }));
};
exports.DateRangeFilter = DateRangeFilter;